import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/attendance-management-system/absence-management/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "absence-management" entry is kept); the seo block below is a fallback.

export const absenceManagement: ContentPage = {
  slug: "attendance-management-system/absence-management",
  template: "hrmsFeature",
  seo: {
    title: "Advanced Absence Management for Modern Workplaces",
    description: "Automate leave management with customizable policies, automated approvals, and real-time balance tracking for efficiency and policy compliance.",
    keywords: [
      "absence management",
      "leave tracking system",
      "automated leave management",
      "employee leave balance",
      "leave policy automation.",
    ],
    ogImage: "/assets/data/seoimages/absence-management.webp",
  },
  leaf: {
    hero: {
      caption: "Absence Management",
      title: "Streamline Leave and Absence Management",
      description: "Efficiently manage and track employee absences and leaves with our comprehensive absence management system, reducing disruptions and ensuring compliance.",
      h1: "caption",
    },
    split: {
      title: "Simplified Leave Management",
      bullets: [
        { title: "Customizable Policies", description: "Tailor leave rules to fit company needs." },
        { title: "Automated Approvals", description: "Accelerate leave approvals with automated workflows." },
        { title: "Balance Tracking", description: "Track and manage leave balances automatically." },
        { title: "Detailed Reporting", description: "Generate reports on leave usage and trends." },
      ],
      image: "/assets/images/img/product/hrms/attendancems/absence-management.webp",
      imageAlt: "absence-management",
    },
    cardsHeading: {
      title: "Key Features of Attendance Management System",
      description: "Optimize Attendance management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Real-Time Attendance Tracking",
        href: "/hrms-software/attendance-management-system/real-time-attendance-tracking",
        description: "Capture accurate employee attendance data in real-time, streamlining payroll processes and enhancing workforce management.",
        image: "/assets/images/img/product/hrms/attendancems/real_time-attendance_tracking_key_features.webp",
        imageAlt: "real_time-attendance_tracking_key_features",
      },
      {
        title: "Overtime Monitoring",
        href: "/hrms-software/attendance-management-system/overtime-monitoring",
        description: "Ensure fair compensation and compliance with our sophisticated overtime monitoring system, reducing discrepancies and boosting morale.",
        image: "/assets/images/img/product/hrms/attendancems/overtime-monitoring_key_features.webp",
        imageAlt: "overtime-monitoring_key_features",
      },
      {
        title: "Shift Management",
        href: "/hrms-software/attendance-management-system/shift-management",
        description: "Manage and automate employee shifts efficiently to ensure coverage and reduce scheduling conflicts with our advanced shift management tools.",
        image: "/assets/images/img/product/hrms/attendancems/shift_management_key_features.webp",
        imageAlt: "shift_management_key_features",
      },
      {
        title: "Geofencing Attendance",
        href: "/hrms-software/attendance-management-system/geofencing-attendance",
        description: "Utilize geofencing technology to manage employee attendance more securely and accurately, ideal for remote or on-site tracking.",
        image: "/assets/images/img/product/hrms/attendancems/geofencing_attendance_key_features.webp",
        imageAlt: "geofencing_attendance_key_features",
      },
    ],
    testimonials: {
      title: "200+ Businesses across India love & trust us!",
      description: "Know why Superworks is the best HR software in India",
    },
    bookDemoTitle: "Optimize Your Leave Management Now!",
    relatedBlogsKeyword: "hrms-leave-and-absence-management,hrms-attendance-management-dashboard",
    metaKey: "absence-management",
  },
  sections: [],
};
